module.exports = __webpack_public_path__ + "img/wordpress.e4a47150.svg";